<template>
  <div class="home _width">
    <!-- header_fxed -->
    <!-- <HelloWorld msg="传给子组件的值" /> -->
    <Header></Header>
    <!-- header_fxed end -->

    <!-- conter -->
    <div class="conter_wp _width">
      <!-- 居中 -->
      <div class="wrap loginBox">
        <div class="flex_conter">
          <!-- 切换头部 -->
          <div class="topBar_lb">
            <img src="@/assets/image/logo.png" alt="" />
          </div>
          <!-- 切换头部 end-->

          <div class="login_conter">
            <!-- 注册 -->
            <div class="mainBox">
              <div class="loginMain clearfix">
                <div class="loginMain_fp-right">
                  <h2>忘记密码</h2>

                  <div class="loginInfo">
                    <p class="loginTip">{{ login_tips }}</p>
                    <form>
                      <input
                        type="text"
                        class="phoneInput_fp fl"
                        v-model="pwd_data.phone"
                        @blur="focus_on(pwd_data.phone, 'blur')"
                        placeholder="请输入手机号码"
                      />
                    </form>

                    <div class="verifyBar_fp fl _width">
                      <input
                        type="text"
                        v-model="pwd_data.phone_code"
                        placeholder="手机验证码"
                        autocomplete="off"
                        :disabled="disabled_resigin_code == false"
                        id="verifyNum_fp"
                      />

                      <button
                        class="verifyBtn_fp"
                        v-if="disabled_resigin_code == false"
                        :disabled="disabled_resigin_code == false"
                      >
                        获取验证码
                      </button>
                      <button
                        class="verifyBtn_fp2 fl"
                        v-else
                        @click="on_phone_code"
                      >
                        {{ item_code }}
                      </button>
                    </div>
                    <form>
                      <div style="height: 1rem; clear: both">
                        <input
                          type="password"
                          style="margin-top: 0.25rem; margin-bottom: 0.05rem"
                          v-model="pwd_data.password"
                          class="passwordInput_fp fl"
                          autocomplete="off"
                          placeholder="密码须包含大小写字母、数字和特殊字符，长度至少8位"
                          @keyup="passwordCheck"
                        />
                        <p class="pwdColor">
                          <span class="c1"></span>
                          <span class="c2"></span>
                          <span class="c3"></span>
                        </p>
                        <p class="pwdText">
                          <span>弱</span>
                          <span>中</span>
                          <span>强</span>
                        </p>
                      </div>
                    </form>
                    <form>
                      <input
                        type="password"
                        v-model="pwd_data.password_s"
                        class="passwordInput_fps fl"
                        autocomplete="off"
                        placeholder="请确认与新密码保持一致"
                      />
                    </form>

                    <input
                      type="button"
                      @click="login_commit()"
                      class="findPswBtn fl"
                      value="确认"
                    />

                    <!-- <input type="button"
                           v-else
                           class="findPswBtn fl"
                           :class="disabled_resigin ==false ? 'btn_null':''"
                           :disabled="disabled_resigin ==false"
                           value="确认"> -->
                  </div>
                </div>

                <!-- mainBox end -->
              </div>
            </div>
          </div>
        </div>
        <!-- 居中 end-->
      </div>
    </div>
    <!-- conter end -->

    <!-- footer end-->
    <!-- <is_http></is_http> -->
  </div>
</template>

<script>
// import is_http from '@/components/common/is_http.vue'

import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";

import {
  forgotpwd,
  testing_phone,
  sendMessage,
  getInitParams,
} from "@/utils/api/login.js";
import crypto from "../../assets/js/crypto";
export default {
  data() {
    return {
      topHeight: "",

      // 登录----------
      login_tips: "",
      phone_code: {},
      pwd_data: {
        phone: "", //手机号
        phone_code: "", //验证码
        password: "", //密码
        password_s: "", //再一次密码
      },
      // pwd_data: {},
      disabled_resigin_code: false, //验证码按钮
      disabled_resigin: false, //false 注册不可点击  true 注册可以点击
      // 发送验证码
      item_code: "发送验证码",
      timer: null,
    };
  },
  watch: {
    topHeight(val) {
      this.topHeight = val;
    },
  },
  created() {
    // 登录获取初始化参数
    this.getInitParams();
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.topHeight = this.windowHeight - 190 + "px";
    window.onresize = () => {
      return (() => {
        this.windowHeight = window.innerHeight;
        this.topHeight = this.windowHeight - 190 + "px";
      })();
    };
  },
  methods: {
    getInitParams() {
      getInitParams().then((res) => {
        localStorage.setItem("aesIv", res.data.data.aesIv);
        localStorage.setItem("aesKey", res.data.data.aesKey);
      });
    },
    // 手机号焦点事件 触发验证
    focus_on(name, type) {
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (name == "" || name == undefined || name == null) {
        this.login_tips = "请输入手机号";
        return;
      } else {
        if (!reg.test(name) && name !== "") {
          this.login_tips = "请输入正确的电话号码";
          return;
        } else {
          let params = { phone: name };
          this.testing_phone(params); //验证手机号
        }
      }
    },

    // 验证手机号
    async testing_phone(name) {
      let { data } = await testing_phone(name);
      this.testing = data;
      if (this.testing.status == 301) {
        // this.login_tips = '该手机号已经注册'
        this.login_tips = ""; //清空提示
        this.disabled_resigin_code = true; //验证码按钮可以点击
      } else if (this.testing.status == 300) {
        this.login_tips = "该手机号尚未注册";
      }
    },

    // 发送手机验证码
    on_phone_code() {
      // this.item_code = ''
      const time_out = 60;
      if (!this.timer) {
        this.item_code = time_out;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.item_code > 0 && this.item_code <= time_out) {
            this.item_code--;
          } else {
            // this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            this.disabled_resigin_code = true;
            this.item_code = "获取验证码";
          }
        }, 1000);
        console.log(this.pwd_data.phone);
        let params = { phone: this.pwd_data.phone };
        this.sendMessage(params); //验证手机号
      }
    },

    // 发送手机验证码
    async sendMessage(name) {
      let { data } = await sendMessage(name);
      // this.testing = data;
      console.log(data);
      this.disabled_resigin = true; //注册按钮可以点击
    },
    passwordCheck() {
      if (this.pwd_data.password == "") {
        $(".pwdColor").hide();
        $(".pwdText").hide();
      } else {
        $(".pwdColor").show();
        $(".pwdText").show();
      }
      this.checkpwd();
    },
    //全部都是灰色的
    primary() {
      $("p.pwdColor span").removeClass("co1,co2,co3");
    },
    //密码强度为弱的时候
    weak() {
      $("span.c1").addClass("co1");
      $("span.c2").removeClass("co2");
      $("span.c3").removeClass("co3");
    },
    //密码强度为中等的时候
    middle() {
      $("span.c1").addClass("co1");
      $("span.c2").addClass("co2");
      $("span.c3").removeClass("co3");
    },

    //密码强度为强的时候
    strong() {
      $("span.c1").addClass("co1");
      $("span.c2").addClass("co2");
      $("span.c3").addClass("co3");
    },
    /**判断密码的强弱规则
    1、如果是单一的字符（全是数字 或 字母 ）长度小于 6  弱
    2、如果是两两混合 (数字+字母（大小） 或 数字+特殊字符  或 特殊字符+字母  长度大于 8  中)
    3、如果是三者组合 (数字 +大写字母+小写字母 或 数字+字母+特殊字符 长度>8  强）)
  **/
    //密码强弱判断函数
    checkpwd() {
      var txt = this.pwd_data.password.trim(); //输入框内容 trim处理两端空格
      var len = txt.length;
      var num = /\d/.test(txt); //匹配数字
      var small = /[a-z]/.test(txt); //匹配小写字母
      var big = /[A-Z]/.test(txt); //匹配大写字母
      var corps = /\W/.test(txt); //特殊符号
      var val = num + small + big + corps; //四个组合

      if (len < 1) {
        this.primary();
      } else if (len < 8) {
        if (val == 1) {
          this.weak();
        } else if (val == 2) {
          this.middle();
        }
      } else if (len >= 8) {
        if (val == 1) {
          this.weak();
        } else if (val >= 2 && val < 4) {
          this.middle();
        } else if (val == 4) {
          this.strong();
        }
        return false;
      }
    },

    // 登录
    login_commit() {
      // 防止重复点击  时间1s
      // this.isDisable = true;
      // setTimeout(() => {
      //   this.isDisable = false;
      // }, 1000); //

      // console.log(this.pwd_data);
      // var pwdRegex = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/;
      var pwdRegex =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/;
      if (this.pwd_data.phone == "") {
        this.login_tips = "手机号不能为空！";
        return;
      }
      if (this.pwd_data.phone_code == "") {
        this.login_tips = "请输入验证码！";
        return;
      }
      if (this.pwd_data.password == "") {
        this.login_tips = "新密码不能为空！";
        return;
      }
      if (!pwdRegex.test(this.pwd_data.password)) {
        // layer.alert("密码中必须包含大小写字母、数字、特殊字符,长度为8");
        this.login_tips = "密码须包含大小写字母、数字和特殊字符，长度至少8位";
        return;
      }
      if (this.pwd_data.password_s == "") {
        this.login_tips = "确认密码不能为空！";
        return;
      }
      if (this.pwd_data.password_s !== this.pwd_data.password) {
        this.login_tips = "两次密码不一致！";
        return;
      }
      this.login_tips = "";
      let params = {
        phone: crypto.encrypt(this.pwd_data.phone),
        code: this.pwd_data.phone_code,
        //密码加密传输
        password: crypto.encrypt(this.pwd_data.password_s),
      };

      this.forgotpwd(params);
    },

    // 忘记密码
    async forgotpwd(name) {
      let { data } = await forgotpwd(name);
      // this.pwd_data = data;
      console.log(data);
      if (data.status == 200) {
        this.$message({
          message: "密码修改成功",
          type: "success",
        });
        this.$router.push({ path: "/login?state=1" }); //跳转页面 默认
      } else {
        this.login_tips = data.msg;
        return false;
      }
    },
  },
  components: {
    Header,
    Footer,
    // is_http
  },
};
</script>

<style scoped>
@import "../../assets/css/login/forget_pwd.css";
.home >>> .header_fxed {
  background: none;
  background-image: none;
  border: none;
  box-shadow: none;
  backdrop-filter: blur(0) !important;
}
.home >>> .login_hide {
  display: none !important;
}

.conter_wp {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-height: 750px;
}
.home {
  position: relative;
  background-size: 100%;
  background-image: url(../../assets/image/banner/login.png);
}
.wrap {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  /* margin-top: 1rem; */
}
.login_conter {
  min-height: 4.8rem;
}
.loginTip {
  line-height: 0.3rem;
  color: #d4011a;
  height: 0.3rem;
  min-height: 0.3rem;
  font-size: 0.14rem;
}
.passwordInput_fp {
  margin-bottom: 6px;
}
p.pwdColor {
  width: 150px;
  height: 5px;
  /* margin-top: 6px; */
  margin-left: 2px;
  display: none;
  clear: both;
}

p.pwdColor span {
  display: inline-block;
  width: 40px;
  height: 4px;
  float: left;
  margin-right: 10px;
  background: #ccc;
}

p.pwdText {
  margin-left: 2px;
  display: none;
}

p.pwdText span {
  margin-right: 20px;
  margin-left: 13px;
  font-size: 12px;
  color: #ddd;
}

p.pwdColor span.co1 {
  background: #f00;
}

p.pwdColor span.co2 {
  background: #00ff66;
}

p.pwdColor span.co3 {
  background: #0033cc;
}
.loginMain_fp-right .passwordInput_fps {
  margin-top: 0 !important;
}
.verifyBar_fp {
  margin-top: 0.25rem;
}
.findPswBtn {
  margin-top: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/login/forget_pwd.vue